'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var selectWrapper_styles = require('./select-wrapper.styles-0104a777.js');

var SelectWrapper = function (_a) {
    var required = _a.required, name = _a.name, value = _a.value, handleChange = _a.onChange, children = _a.children, isSelected = _a.isSelected;
    return (React__default.createElement(selectWrapper_styles.SelectWrapperStyled, { className: "wrapper" },
        React__default.createElement(selectWrapper_styles.CaretDownIcon, { variant: "adminGreyDark", className: "caret" }),
        React__default.createElement(selectWrapper_styles.StyledSelect, { className: "select", value: value !== null && value !== void 0 ? value : '', isSelected: isSelected, onChange: handleChange, required: required, name: name, "data-cy": "select", "data-testid": "select" }, children)));
};

exports.SelectWrapper = SelectWrapper;
